<h2>{{ title | translate }}</h2>
<div class="modal-content">
  @if (items) {
    @for (item of items; track $index) {
      <kin-scenic-card
        [information]="item"
        [details]="true"
        [condensed]="false"
        [animate]="true"
        size="small"
        (onCardClick)="onCardClick(item)"
        (onAuthorClick)="onAuthorClick(item)" />
    }
  } @else {
    @for (item of [].constructor(6); track $index) {
      <kin-scenic-card
        [details]="true"
        [condensed]="false"
        [animate]="true"
        size="small" />
    }
  }
</div>
